export default "__VITE_ASSET__b2b98432__"